// TOPページの企業ロゴを Swiper で連続スクロール（マーキー）表示する。
// 対象HTML（.js-top-slider）が無いページでは何もしない。
// data-offset="half"     : スライド幅の半分だけ位相をずらす（上下段を互い違いに見せる）。
// data-direction="reverse": 逆向き（右→左ではなく左→右）にスクロールする。
export function initTopSlider () {
  const sliders = document.querySelectorAll('.js-top-slider');
  if (!sliders.length || typeof Swiper === 'undefined') return;

  sliders.forEach((slider) => {
    const halfOffset = slider.dataset.offset === 'half';
    const reverse = slider.dataset.direction === 'reverse';

    // スライド1枚の幅の半分を offset として返す
    const getOffset = () => {
      if (!halfOffset) return 0;
      const slide = slider.querySelector('.swiper-slide');
      return slide ? slide.offsetWidth / 2 : 0;
    };

    const swiper = new Swiper(slider, {
      slidesPerView: 'auto',
      spaceBetween: 0,
      loop: true,
      speed: 4000,          // 大きめの値でゆっくり連続スクロール
      allowTouchMove: false,
      grabCursor: false,
      slidesOffsetBefore: getOffset(),
      autoplay: {
        delay: 0,           // 途切れずに流し続ける
        disableOnInteraction: false,
        reverseDirection: reverse,
      },
      breakpoints: {
        769: {
          spaceBetween: 32, // PC は 2rem 分の余白
        },
      },
    });

    // リサイズでスライド幅が変わっても半分ずれを保つ
    if (halfOffset) {
      window.addEventListener('resize', () => {
        swiper.params.slidesOffsetBefore = getOffset();
        swiper.update();
      });
    }
  });
}
